const COMPARE_TRAY_ROOTS = ["/", "/home"];
const COMPARE_TRAY_PREFIXES = ["/category", "/search", "/product", "/products"];

/** Compare tray belongs on catalog pages where products can be selected. */
export function comparisonTrayAllowed(pathname = "") {
  if (COMPARE_TRAY_ROOTS.includes(pathname)) return true;
  return COMPARE_TRAY_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
